import React, { useCallback, useState } from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faCheckSquare, faSquare } from '@fortawesome/free-solid-svg-icons';

interface CheckboxSortOptionProps {
    isSelected: boolean,
    setSelected: () => void;
}

export const CheckboxSortAscendingComponent = ({isSelected, setSelected}: CheckboxSortOptionProps) => {
    const btnClass = classNames('field-sort-button', {
        'field-sort-button--is-selected': isSelected,
    })
    return (
        <div className={btnClass} onClick={setSelected}><FontAwesomeIcon icon={faSquare} /> <FontAwesomeIcon icon={faArrowRight} /> <FontAwesomeIcon icon={faCheckSquare} /></div>
    )
}

export const CheckboxSortDescendingComponent = ({isSelected, setSelected}: CheckboxSortOptionProps) => {
    const btnClass = classNames('field-sort-button', {
        'field-sort-button--is-selected': isSelected,
    })
    return (
        <div className={btnClass} onClick={setSelected}><FontAwesomeIcon icon={faCheckSquare} /> <FontAwesomeIcon icon={faArrowRight} /> <FontAwesomeIcon icon={faSquare} /></div>
    )
}
